export const currency = 'CHF';
export const locale = 'de-CH';

export const sortBy = (list, property) => {
  const copy = [...list];

  return copy.sort((a, b) => b[property] - a[property]);
};
